import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setDivisionBikesData } from '../../redux/divisionBikesReducer'
import { getDivisionBikesData } from '../divisionBikes/services/getDivisionBikesData'
import { errorMessage, openMessage, successfullyMessage } from '../Messages'

export function useInitDivisionBikesData({ data, fDate, eDate, division, date = undefined }) {

    const dispatch = useDispatch()
    const [lastFilterDates, setLastFilterDates] = useState({})

    const initDivisionBikesData = useCallback(async () => {
        openMessage({ message: "Cargando..." })
        const { result, message, error_msg } = await getDivisionBikesData({ fDate, eDate, division, date })
        if (message.includes('Successfully')) {
            successfullyMessage({ message: "Datos Cargados" })
            dispatch(setDivisionBikesData(result))
        } else if (!!error_msg) {
            errorMessage({ message: "Ocurrió un error" })
        }
    }, [dispatch, fDate, eDate, division, date])

    useEffect(() => {
        (async () => {
            if (data?.length > 0 && !!fDate && !!eDate) {
                if (fDate !== lastFilterDates?.fDate || eDate !== lastFilterDates?.eDate) {
                    initDivisionBikesData()
                    setLastFilterDates({ ...lastFilterDates, fDate: fDate, eDate: eDate })
                }
            } else if (data?.length === 0 && !!fDate && !!eDate) {
                initDivisionBikesData()
                setLastFilterDates({ ...lastFilterDates, fDate: fDate, eDate: eDate })
            }
        })()
    }, [data, fDate, eDate, division, date])

}